import ProgressIndicatorWithNumber from './progress-indicator-with-number';

export default ProgressIndicatorWithNumber;
